import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { Doc } from '@/api/types/backend-dto-types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetDoc = (
  matterId: string | undefined,
  docId: string | null,
  subsetId?: string,
  includeSurroundingDocIds = false,
) => {
  const fetcher = useFetcher();

  const queryParams = new URLSearchParams();
  if (subsetId) {
    queryParams.set('subsetId', subsetId);
  }
  if (includeSurroundingDocIds) {
    queryParams.set('includeSurroundingDocIds', 'true');
  }
  const queryString = queryParams.toString();

  return useQuery<Doc, ApiError>(
    [QueryEntity.Doc, { docId, subsetId, includeSurroundingDocIds }],
    () =>
      fetcher<Doc>(`${APIBaseChronos}/api/matters/${matterId}/docs/${docId}${queryString ? `?${queryString}` : ''}`),
    {
      enabled: !!matterId && !!docId,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error.code !== 404 && error.code !== 403 && failureCount < 3,
    },
  );
};
